<template>
  <!-- Content Wrapper. Contains page content -->
  <div id="content-wrap" class="content-wrapper">
    <router-view></router-view>
  </div>
  <!-- /.content-wrapper -->
</template>

<script>
import { mapState } from "vuex";
export default {
  name: 'va-content-wrap',
  created () {

  },
  computed: {
    ...mapState({
      topic: store => store.Menu.topic
    })
  }
}
</script>

<style>

/* div.content-wrapper {
  height: 1000px !important;
} */
.page-enter-active,
.page-leave-active {
  transition: opacity .5s, transform .5s;
}
.page-enter,
.page-leave-to {
  opacity: 0;
}
</style>